import { z, type ZodType } from '@customerio/hydra-validation';
import type { UserMinimal } from '@customerio/hydra-ui-api';

/**
 * The person a record names as its creator or last editor, as the API embeds
 * them (`UserMinimal`). Shared by every entity that carries `created_by_user`
 * or `updated_by_user`.
 */
export const UserMinimalFromApi: ZodType<UserMinimal, unknown> = z.object({
  id: z.string(),
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  profile_image_url: z.string().nullish(),
});
